import axios from "axios";
const SIGNIN_API_URL = process.env.REACT_APP_SIGNIN_API_URL;

export const signInWithEmail = async (email, isSchedule) => {
  console.log(SIGNIN_API_URL, email);
  return await axios.post(`${SIGNIN_API_URL}/email`, { email, isSchedule });
};

export const signInWithCode = async (data) => {
  return await axios.post(`${SIGNIN_API_URL}/login`, data);
};
